import { Icon } from "@chakra-ui/react";

export const CartIcon = (props) => (
  <Icon width="6" height="6" fill="none" {...props}>
    <path
      fill="#4B4F54"
      d="M9.804 21.567a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM20.134 21.567a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
    />
    <path
      fill="#D11243"
      d="m20.777 17.202-8.225-.11c-1.838 0-3.612-1.627-3.943-3.566L6.927 4.124c0-.019-.009-.037-.009-.055-.377-1.737-1.7-1.627-1.7-1.627s-1.7-.018-2.831 0c-1.112.018-1.333.662-1.37.891 0 .028-.009.129-.009.35 0 .404.313.762.818.735l2.877-.12a.66.66 0 0 1 .763.506l1.957 9.034v.037c.589 2.472 2.482 4.2 4.945 4.2h7.674c.414 0 .781-.073.974-.34.157-.22.019-.524-.239-.533Z"
    />
    <path
      fill="#4B4F54"
      d="M20.41 7.359H9.16a.288.288 0 0 0-.284.33c0 .01.009.02.009.028l.009-.064s.018.505 1.397.57l9.797.487c.827.018 1.351.542 1.222 1.287l-.634 3.878c-.1.533-.57.919-1.112.91l-8.216-.276a.226.226 0 0 0-.22.267.86.86 0 0 0 .799.698l7.895.313a2.253 2.253 0 0 0 2.352-1.894l.754-3.612c.404-2.297-.956-2.922-2.518-2.922Z"
    />
  </Icon>
);
